import React, { ComponentPropsWithoutRef, FunctionComponent } from 'react';
import styled from '../styled';
import { SectionHeading } from 'system/base/Heading';
import Box from 'system/base/Box';
import Space from 'system/utility/Space';
import Icon, { IconName } from 'system/base/Icon';

const ActionableBox = styled(Box)(({ theme }) => ({
  '&:hover, &:active': {
    border: (theme as any).borders.actionable,
  },
  cursor: 'pointer',
}));

type CommonProps = {
  primary?: boolean;
  actionable?: boolean;
};

type PropsWithoutTitle = {
  iconName?: never;
} & ComponentPropsWithoutRef<typeof Box>;

type PropsWithTitle = {
  title: string;
  iconName?: IconName;
} & ComponentPropsWithoutRef<typeof Box>;

type Props = CommonProps & (PropsWithoutTitle | PropsWithTitle);

const Panel: FunctionComponent<Props> = ({
  primary,
  actionable,
  title,
  iconName,
  children,
  ...props
}: Props) => {
  const WrapperBox = actionable ? ActionableBox : Box;

  const primaryProps = primary
    ? {
        p: 4,
        boxShadow: 'light',
      }
    : {};

  return (
    <WrapperBox colors="onWhite" p={3} {...primaryProps} {...props}>
      {title && (
        <Space marginTop={0} marginBottom={2}>
          <SectionHeading>
            {iconName && <Icon name={iconName} />}
            {iconName && ' '}
            {title}
          </SectionHeading>
        </Space>
      )}
      {children}
    </WrapperBox>
  );
};

Panel.defaultProps = {
  border: 'panel',
};

export default Panel;
